






















































import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import {
    FormBase,
    FormTextarea,
    FormInput,
    FormCheckbox,
    FormError,
    FormSubmit
} from "@components/forms";
import axios from "axios";

@Component({
    components: {
        FormBase,
        FormInput,
        FormTextarea,
        FormCheckbox,
        FormError,
        FormSubmit
    }
})
export default class ContactForm extends Vue {
    @Prop() open!: boolean;

    @Ref() form!: FormClass;

    errorResponse: ErrorResponse = {
        status: 0,
        errors: []
    };

    privacyAgreement: boolean = false;

    payload = {
        email: "",
        name: "",
        phone: "",
        comment: ""
    };

    private submit() {
        axios
            .post("/api/contact", this.payload)
            .then(() => {
                this.form.succeeded();
            })
            .catch(
                (errorResponse: ErrorResponse) =>
                    (this.errorResponse = errorResponse)
            )
    }
}
